import React, { useState } from 'react';
import LayoutContext, { DEFAULT_WRAPPER_CLASS } from './Layout.context';

const LayoutProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  const [wrapperClass, setWrapperClass] = useState<string>(
    DEFAULT_WRAPPER_CLASS,
  );

  return (
    <LayoutContext.Provider
      value={{
        setWrapperClass,
        wrapperClass,
        defaultWrapperClass: DEFAULT_WRAPPER_CLASS,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
